import { Button } from 'blaze-ui/Button/Button'
import Styles from './MobileStopForStrategies.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { UserClient } from 'api/clients/UserClient'
import { useAuth } from 'hooks/UseAuth'
import { useEffect, useRef, useState } from 'react'
import { SupportChat } from 'components/FirstTimeExperienceModal/components/SupportChat/SupportChat'
import { MoreDots } from 'blaze-ui/icons'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'
import { ThreeDotMenuDrawer } from 'screens/VirtualMarketerOnboarding/ThreeDotMenuDrawer/ThreeDotMenuDrawer'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { generatePath, useHistory } from 'react-router-dom'
import { BLAZE_HOME_PATH } from 'paths'

export const MobileStopForStrategies = observer(() => {
  const workspaceId = useCurrentWorkspaceId()
  const history = useHistory()
  const auth = useAuth()
  const [emailSent, setEmailSent] = useState(false)
  const { drawersStore } = useRootStore()
  const hasRedirected = useRef(false)

  const handleEmail = () => {
    // eslint-disable-next-line no-restricted-properties
    UserClient.sendMobileAutopilotDesktopLinkEmail(window.location.href)
    setEmailSent(true)
  }

  const openLogoutDrawer = () => {
    drawersStore.openDrawer(ThreeDotMenuDrawer)
  }

  useEffect(() => {
    if (hasRedirected.current) return

    hasRedirected.current = true
    history.push(generatePath(BLAZE_HOME_PATH, { workspaceId }))
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={Styles.root}>
      <div className={Styles.options}>
        <IconButton variant="tertiary" onPress={openLogoutDrawer} icon={MoreDots} />
        <SupportChat mobile />
      </div>
      <div className={Styles.content}>
        <img
          className={Styles.image}
          src="https://res.cloudinary.com/almanac/image/upload/v1773750455/blaze_assets/virtual_marketer/onboarding/Frame_1171277093_i0xtxn.png"
          alt="Mobile Stop Graphic"
        />
        <div className={Styles.footer}>
          <div className={Styles.textContainer}>
            <Heading level={1}>Blaze is best on a bigger screen.</Heading>
            <Text variant="secondary">We'll send you a link — open it on your laptop when you're ready.</Text>
          </div>
          <div className={Styles.bottom}>
            <Button size="lg" onPress={handleEmail} isDisabled={emailSent} fullWidth>
              {emailSent ? 'Email sent' : 'Send to ' + auth?.email}
            </Button>
            {emailSent && (
              <Text variant="metadata" color="var(--dark-40)">
                Didn't get the email?{' '}
                <button type="button" onClick={handleEmail}>
                  Try again
                </button>
              </Text>
            )}
          </div>
        </div>
      </div>
    </div>
  )
})
